import {
    Button,
    Card,
    CardBody,
    CardHeader,
    CardText,
    CardTitle,
    Col, Form, FormGroup,
    Input, Label,
    Row,
    UncontrolledTooltip
} from "reactstrap";
import React, {Fragment, useEffect, useState} from "react";
import {SlideDown} from "react-slidedown";
import {ArrowLeft, ArrowRight, Plus, Trash2, X} from "react-feather";
import Select from "react-select";
import {selectThemeColors} from "../../../utility/Utils";
import Breadcrumbs from '@components/breadcrumbs'
import {useHistory, useParams} from "react-router-dom";
import {useDispatch, useStore} from "react-redux";
import axios from "axios";

import FooterButtons from "../../components/FooterButtons";
import {getUserData} from "../../../auth/utils";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {getCurrentOrganisationName} from "../../../utility/UserUtility";
import Creatable from "react-select/creatable";
import {isSportWithDisciplines} from "../DetaljiNatjecanja/CompetitionPhase";
import FileUploaderMulti from "../../../utility/FIleUploaderMulti";

const MySwal = withReactContent(Swal)


export function fixLayoutToFullScreen() {
    try {
        document.getElementsByClassName("card-body")[0].style.height = "100%";
        document.getElementsByClassName("content-wrapper")[0].style.height = "100%";
        document.getElementsByClassName("app-content")[0].style.height = "100%";
        document.getElementsByClassName("card")[0].style.height = "93%";
        document.getElementsByClassName("footer")[0].style.display = "none";
    } catch (e) {
    }
}

const NovoNatjecanjeKorak1 = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const params = useParams();
    let isEdit = !!params.id;
    const store = useStore();
    const reduxState = store.getState();
    let oldData = (reduxState.natjecanja && reduxState.natjecanja.newNatjecanjeStep1Data) ? reduxState.natjecanja.newNatjecanjeStep1Data : {};
    const [currentSeason, setCurrentSeason] = useState(oldData.currentSeason ? oldData.currentSeason : {
        value: '',
        label: 'Odaberi sezonu'
    })
    const [currentSequence, setCurrentSequence] = useState({value: 'sekvenca', label: 'sekvenca'})
    const [currentSport, setCurrentSport] = useState(oldData.currentSport ? oldData.currentSport : {
        value: '',
        label: 'Odaberi sport'
    })
    const [currentLeague, setCurrentLeague] = useState(oldData.currentLeague ? {
        label: oldData.currentLeague,
        value: oldData.currentLeague
    } : {
        value: '',
        label: 'Odaberi ligu'
    })
    const [sex, setSex] = useState(oldData.sex ? oldData.sex : {value: '', label: 'Odaberi spol'})
    const [delegateType, setDelegateType] = useState(oldData.delegateType ? oldData.delegateType : {
        value: '',
        label: 'Odaberi model natjecanja'
    })

    const [options] = useState([
        {
            value: "Propozicije",
            label: "Propozicije"
        },
        {
            value: "Pravilnik",
            label: "Pravilnik"
        },
        {
            value: "Upute",
            label: "Upute"
        },
        {
            value: "Ostalo",
            label: "Ostalo"
        },
    ]);

    const [seasons, setSeasons] = useState({value: '', label: 'Odaberi sezonu'})
    const [sequences, setSequences] = useState({value: '', label: 'Odaberi sekvencu'})
    const [sports, setSports] = useState({value: '', label: 'Odaberi sport'})
    const [leagues, setLeagues] = useState({value: '', label: 'Odaberi ligu'})
    const [chosenCompetition, setChosenCompetition] = useState(false);
    const [filesDetails, setFilesDetails] = useState([]);
    const [name, setName] = useState(oldData.name ? oldData.name : "");
    const [maxDisciplines, setMaxDisciplines] = useState(oldData.maxDisciplines ? oldData.maxDisciplines : "");
    const [validationFailed, setValidationFailed] = useState(false);


    function fetchLeagues(sex, currentSport) {
        if (sex.value != "" && currentSport.value != "") {
            axios.get(`${process.env.REACT_APP_MAIN_URL}/admin/get-core-competitions?sport=${currentSport.label}&sex=${sex.value}`).then((result) => {
                let seasonResults = result.data.coreCompetitions.map((season) => {
                    return {
                        value: season,
                        label: season.name
                    }
                });
                setLeagues(seasonResults);
            })
        }
    }

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_MAIN_URL}/admin/seasons`).then((result) => {
            let seasonResults = result.data.seasons.map((season) => {
                return {
                    value: season,
                    label: season
                }
            });
            setSeasons(seasonResults);
        })
        axios.get(`${process.env.REACT_APP_MAIN_URL}/admin/sports`).then((result) => {
            let sportsResults = result.data.sports.map((sport) => {
                return {
                    value: sport,
                    label: sport
                }
            });
            console.log("Sports results", sportsResults)
            setSports(sportsResults);
        })
        fixLayoutToFullScreen();

        if (isEdit) {
            axios.get(`${process.env.REACT_APP_MAIN_URL}/admin/get-one-competition?competitionId=${params.id}`).then((result) => {
                let myCompetition = result.data.competition;
                console.log("My competition", myCompetition)
                setChosenCompetition(myCompetition);
                setName(myCompetition.name)
                setCurrentSport({
                    label: myCompetition.sport.name,
                    value: myCompetition.sport.name,
                })
                setCurrentSequence({
                    label: myCompetition.sequence,
                    value: myCompetition.sequence,
                })
                setCurrentSeason({
                    label: myCompetition.season.name,
                    value: myCompetition.season.name,
                })
                fetchLeagues({
                        label: myCompetition.sex,
                        value: myCompetition.sex
                    },
                    {
                        label: myCompetition.sport.name,
                        value: myCompetition.sport.name
                    });
                setCurrentLeague({
                    label: myCompetition.league,
                    value: myCompetition.league
                })
                if (myCompetition.sex) {
                    setSex({
                        label: myCompetition.sex === "M" ? "muški" : "ženski",
                        value: myCompetition.sex,
                    })
                }
                if (myCompetition.delegateType) {
                    setDelegateType({
                        label: myCompetition.delegateType,
                        value: myCompetition.delegateType,
                    })
                }

                let fileDetailsPrepared = [];
                if (myCompetition.files) {
                    myCompetition.files.map((singleFile) => {
                        fileDetailsPrepared.push({
                            documentType: {
                                value: singleFile.typeOf,
                                label: singleFile.typeOf
                            },
                            name: singleFile.name,
                            documentName: singleFile.name,
                            uploadUrl: singleFile.url,
                            url: singleFile.url,
                            _id: singleFile._id
                        })
                    })
                    setFilesDetails(fileDetailsPrepared);
                }

            })
        } else {
            let valueFromRedux = reduxState.natjecanja.newNatjecanjeStep1Data;
            if (valueFromRedux && valueFromRedux.currrentSport) {
                setCurrentSport(valueFromRedux.currrentSport)
            }
            if (valueFromRedux && valueFromRedux.currrentSequence) {
                setCurrentSequence(valueFromRedux.currrentSequence)
            }
            if (valueFromRedux && valueFromRedux.currrentSeason) {
                setCurrentSeason(valueFromRedux.currrentSeason)
            }
            if (valueFromRedux && valueFromRedux.currrentLeague) {
                setCurrentLeague(valueFromRedux.currrentLeague)
            }
            if (valueFromRedux && valueFromRedux.sex) {
                setSex(valueFromRedux.sex)
            }
            if (valueFromRedux && valueFromRedux.delegateType) {
                setDelegateType(valueFromRedux.delegateType)
            }

            if (valueFromRedux && valueFromRedux.filesDetails) {
                setFilesDetails(valueFromRedux.filesDetails)
            }
        }


    }, [])

    let sportHasDisciplines = false
    if (currentSport && currentSport.value) {
        let object = {
            sport: {
                name: currentSport.value
            }
        }
        if (isSportWithDisciplines(object)) {
            sportHasDisciplines = true;
        }
    }

    console.log(filesDetails)


    return (
        <Fragment>
            <Breadcrumbs breadCrumbTitle='Natjecanja' breadCrumbParent='Natjecanja' breadCrumbActive='Novo natjecanje'/>
            <Card style={{
                overflowY: "scroll"
            }}>
                <CardHeader>
                    <CardTitle tag='h4'>Podaci o novom natjecanju</CardTitle>
                </CardHeader>

                <CardBody>
                    <Row>
                        <Col className='mb-1' md='6' sm='12'>
                            <Input
                                placeholder={"Naziv"}
                                theme={selectThemeColors}
                                className='react-select'
                                classNamePrefix='select'
                                invalid={name === '' && validationFailed}
                                value={name}
                                onChange={(e) => {
                                    setName(e.target.value)
                                }}

                            />
                        </Col>
                        <Col className='mb-1' md='6' sm='12'>
                            <Select
                                theme={selectThemeColors}
                                className='react-select'
                                classNamePrefix='select'
                                value={currentSeason}
                                styles={{
                                    control: styles => ({
                                        ...styles,
                                        borderColor: (validationFailed && currentSeason.value === "") ? 'red' : styles.borderColor,
                                        '&:hover': {
                                            borderColor: (validationFailed && currentSeason.value === "") ? 'red' : styles['&:hover'].borderColor
                                        }
                                    })
                                }}
                                onChange={(data) => {
                                    setCurrentSeason(data)
                                }}
                                name='clear'
                                options={seasons}
                                isClearable={false}
                            />
                        </Col>
                        <Col className='mb-1' md='6' sm='12'>
                            <Select
                                theme={selectThemeColors}
                                className='react-select'
                                classNamePrefix='select'
                                value={currentSport}
                                styles={{
                                    control: styles => ({
                                        ...styles,
                                        borderColor: (validationFailed && currentSport.value === "") ? 'red' : styles.borderColor,
                                        '&:hover': {
                                            borderColor: (validationFailed && currentSport.value === "") ? 'red' : styles['&:hover'].borderColor
                                        }
                                    })
                                }}
                                onChange={(data) => {
                                    setCurrentSport(data)
                                    fetchLeagues(sex, data);
                                }}
                                options={sports}
                                isClearable={false}
                            />
                        </Col>
                        <Col className='mb-1' md='6' sm='12'>
                            <Creatable
                                theme={selectThemeColors}
                                className='react-select'
                                placeholder={"Liga"}
                                classNamePrefix='select'
                                isDisabled={!isEdit && (currentSport == null || currentSport.value == "" || sex == null || sex.value == "")}
                                value={currentLeague}
                                styles={{
                                    control: styles => ({
                                        ...styles,
                                        borderColor: (validationFailed && currentLeague.value === "") ? 'red' : styles.borderColor,
                                        '&:hover': {
                                            borderColor: (validationFailed && currentLeague.value === "") ? 'red' : styles['&:hover'].borderColor
                                        }
                                    })
                                }}
                                onChange={(data) => {
                                    if (data.__isNew__) {
                                        axios.post(`${process.env.REACT_APP_MAIN_URL}/admin/post-core-competitions`, {
                                            name: data.value,
                                            sport: currentSport.label,
                                            sex: sex.value,
                                        }).then((result) => {
                                            setCurrentLeague(data)
                                        }).catch((e) => {
                                            setCurrentLeague(data)
                                        })
                                    } else {
                                        setCurrentLeague(data)
                                    }
                                }}
                                options={leagues}
                                isClearable={false}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className='mb-1' md='6' sm='12'>
                            <Select
                                theme={selectThemeColors}
                                className='react-select'
                                classNamePrefix='select'
                                value={sex}
                                styles={{
                                    control: styles => ({
                                        ...styles,
                                        borderColor: (validationFailed && sex.value === "") ? 'red' : styles.borderColor,
                                        '&:hover': {
                                            borderColor: (validationFailed && sex.value === "") ? 'red' : styles['&:hover'].borderColor
                                        }
                                    })
                                }}
                                onChange={(data) => {
                                    setSex(data)
                                    fetchLeagues(data, currentSport);
                                }}
                                options={[
                                    {
                                        value: "M",
                                        label: "muški"
                                    },
                                    {
                                        value: "F",
                                        label: "ženski"
                                    }
                                ]}
                                isClearable={false}
                            />
                        </Col>
                        <Col className='mb-1' md='6' sm='12'>
                            <Select
                                theme={selectThemeColors}
                                className='react-select'
                                classNamePrefix='select'
                                value={delegateType}
                                styles={{
                                    control: styles => ({
                                        ...styles,
                                        borderColor: (validationFailed && delegateType.value === "") ? 'red' : styles.borderColor,
                                        '&:hover': {
                                            borderColor: (validationFailed && delegateType.value === "") ? 'red' : styles['&:hover'].borderColor
                                        }
                                    })
                                }}
                                onChange={(data) => {
                                    setDelegateType(data)
                                }}
                                options={[
                                    {
                                        value: "A",
                                        label: "A"
                                    },
                                    {
                                        value: "B",
                                        label: "B"
                                    },
                                    {
                                        value: "C",
                                        label: "C"
                                    }
                                ]}
                                isClearable={false}
                            />
                        </Col>
                    </Row>
                    {sportHasDisciplines &&
                    <Row>
                        <Col className='mb-1' md='6' sm='12'>
                            <Input
                                type={"number"}
                                placeholder={"Max broj disciplina po igraču"}
                                theme={selectThemeColors}
                                className='react-select'
                                classNamePrefix='select'
                                invalid={maxDisciplines === '' && validationFailed}
                                value={maxDisciplines}
                                onChange={(e) => {
                                    setMaxDisciplines(e.target.value)
                                }}

                            />
                        </Col>
                    </Row>
                    }

                    <Row>
                        <Col sm="0" md="3">
                        </Col>
                        <Col sm="12" md="6">
                            <FileUploaderMulti
                                title={"Upload dokumenata (propozicije, pravilnici itd.)"}
                                fileDetails={filesDetails}
                                setFilesDetails={setFilesDetails}
                            />
                        </Col>
                        <Col sm="0" md="3">
                        </Col>
                    </Row>
                    <CardHeader>
                        <CardTitle>Dokumenti</CardTitle>
                    </CardHeader>
                    {filesDetails.map((fileDetail, index) => {
                        return (
                            <Row style={{marginBottom: "15px"}} className={"row"}>
                                <Col md={2}>
                                    <a href={fileDetail.uploadUrl}>{filesDetails[index].name}</a>
                                </Col>
                                <Col md={3}>
                                    <Input
                                        disabled={fileDetail._id != null}
                                        placeholder={"Naziv"}
                                        theme={selectThemeColors}
                                        className='react-select'
                                        classNamePrefix='select'
                                        invalid={(filesDetails[index].documentName == null || filesDetails[index].documentName === '') && validationFailed}
                                        value={filesDetails[index].documentName}
                                        onChange={(e) => {
                                            let newFiles = filesDetails;
                                            newFiles[index].documentName = e.target.value;
                                            setFilesDetails([...newFiles])
                                        }}
                                    />
                                </Col>
                                <Col
                                    md={3}>
                                    <Select
                                        maxMenuHeight={100}
                                        menuPlacement="auto"
                                        isDisabled={fileDetail._id != null}
                                        theme={selectThemeColors}
                                        className='react-select'
                                        classNamePrefix='select'

                                        value={filesDetails[index].documentType}
                                        styles={{
                                            control: styles => ({
                                                ...styles,
                                                borderColor: (validationFailed && (filesDetails[index].documentType === "" || filesDetails[index].documentType == null)) ? 'red' : styles.borderColor,
                                                '&:hover': {
                                                    borderColor: (validationFailed && (filesDetails[index].documentType === "" || filesDetails[index].documentType == null)) ? 'red' : styles['&:hover'].borderColor
                                                }
                                            })
                                        }}
                                        onChange={(data) => {
                                            let newFiles = filesDetails;
                                            newFiles[index].documentType = data;
                                            setFilesDetails([...newFiles])
                                        }}
                                        options={options}
                                        isClearable={false}
                                    />
                                </Col>
                                <Col className={"my-auto"} md={2}>
                                    <Trash2
                                        style={{
                                            cursor: "pointer"
                                        }}
                                        onClick={(e) => {
                                            MySwal.fire({
                                                title: 'Jeste li sigurni',
                                                text: "Klikom na gumb Potvrdi dokument će biti izbrisan",
                                                icon: 'warning',
                                                showCancelButton: true,
                                                confirmButtonText: 'Potvrdi',
                                                cancelButtonText: 'Odustani',
                                                customClass: {
                                                    confirmButton: 'btn btn-primary',
                                                    cancelButton: 'btn btn-outline-danger ml-1'
                                                },
                                                buttonsStyling: false
                                            }).then(function (result) {
                                                if (result.value) {
                                                    axios.post(`${process.env.REACT_APP_MAIN_URL}/admin/delete-competition-document`, {
                                                        competitionId: chosenCompetition._id,
                                                        url: fileDetail.uploadUrl,
                                                    }).then(res => {
                                                        MySwal.fire({
                                                            icon: 'success',
                                                            title: 'Uspješno',
                                                            text: 'Dokument izbrisan.',
                                                            customClass: {
                                                                confirmButton: 'btn btn-success'
                                                            }
                                                        })
                                                        let newFileDetails = filesDetails.filter((oneDetail) => {
                                                            return !(oneDetail.url === fileDetail.url);

                                                        })
                                                        setFilesDetails([...newFileDetails])
                                                    }).catch(err => console.log(err))
                                                }
                                            })
                                        }}
                                        size={18}/>
                                </Col>
                            </Row>
                        )
                    })}

                    <FooterButtons
                        forwardLabel={isEdit ? "Spremi" : "Sljedeće"}
                        step="1"
                        forwardClick={() => {
                            if (name === "" ||
                                currentSeason === "" ||
                                currentSeason === null ||
                                currentSeason.value === "" ||
                                sex === "" ||
                                delegateType === "" ||
                                delegateType.value === "" ||
                                (sportHasDisciplines && maxDisciplines === "") ||
                                sex.value === "" ||
                                currentSport === "" ||
                                currentLeague === "" ||
                                currentLeague.value === "" ||
                                currentLeague.label === ""
                            ) {
                                window.alert("Molimo unesite sve podatke")
                                setValidationFailed(true);
                            } else if (isEdit) {

                                let uploadedDocuments = [];
                                if (filesDetails) {
                                    filesDetails.map((singleFile) => {
                                        uploadedDocuments.push({
                                            url: singleFile.uploadUrl,
                                            name: singleFile.documentName,
                                            typeOf: singleFile.documentType.value
                                        });

                                    })
                                }
                                axios.post(`${process.env.REACT_APP_MAIN_URL}/admin/edit-competition`, {
                                    competitionId: chosenCompetition._id,
                                    name,
                                    files: uploadedDocuments,
                                    maxNumberOfDisciplines: maxDisciplines,
                                    season: currentSeason.label,
                                    sport: currentSport.label,
                                    league: currentLeague.label ? currentLeague.label : currentLeague,
                                    sex: sex.value,
                                    organisation: getCurrentOrganisationName(),
                                    startDate: chosenCompetition.applicationStart.slice(0, 10),
                                    endDate: chosenCompetition.applicationEnd.slice(0, 10),
                                    applicationStart: chosenCompetition.applicationStart.slice(0, 10),
                                    applicationEnd: chosenCompetition.applicationEnd.slice(0, 10),
                                    registrationEnd: chosenCompetition.registrationEnd.slice(0, 10),
                                    constituents: []
                                }).then((result) => {
                                    MySwal.fire({
                                        icon: 'success',
                                        title: 'Uspješno',
                                        text: 'Natjecanje uspješno editirano.',
                                        customClass: {
                                            confirmButton: 'btn btn-success'
                                        }
                                    })
                                    history.replace(`/natjecanja/izmijeni/${chosenCompetition._id}`);
                                }).catch(() => {
                                    MySwal.fire({
                                        icon: 'warning',
                                        title: 'Pogreška',
                                        text: 'Nešto je pošlo po krivu. Molimo probajte ponovno',
                                        customClass: {
                                            confirmButton: 'btn btn-success'
                                        }
                                    })
                                });
                            } else {
                                console.log(filesDetails)
                                dispatch({
                                    type: "NATJECANJE_STEP1",
                                    newNatjecanjeStep1Data: {
                                        currentSeason,
                                        currentLeague: currentLeague.label,
                                        currentSport,
                                        currentSequence,
                                        sex,
                                        delegateType,
                                        maxDisciplines,
                                        name,
                                        filesDetails
                                    }
                                });
                                history.push("/natjecanja/novi-korak-2");
                            }
                        }}
                        backClick={() => {
                            history.replace("/natjecanja");

                        }}
                    />
                </CardBody>
            </Card>
        </Fragment>
    )
}


export default NovoNatjecanjeKorak1;